// styles.tsx for GeneratedVideoItem
// styles.tsx for GeneratedVideoItem
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  generatedVideoItem: {
    position: "relative",
    display: "flex",
    flexDirection: "row", // Changed from column to row
    alignItems: "center", // Align items vertically in the center
    gap: "12px", // Space between video and content
    marginBottom: "16px",
    padding: "12px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#fafafa",
  },
  videoWrapper: {
    position: "relative",
    width: "80px", // Fixed small width for thumbnail
    height: "120px", // Fixed height for vertical videos
    flexShrink: 0, // Prevent the video from shrinking
  },
  videoPlayer: {
    width: "100%",
    height: "100%",
    borderRadius: "4px",
    backgroundColor: "#000",
    objectFit: "cover", // Ensure video covers the container
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1, // Take up remaining space
    gap: "8px",
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  nameSection: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  actionsSection: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  reloadButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
    },
  },
  videoActionButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
    },
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      borderRadius: "4px",
    },
  },
}));

export default useStyles;
